
export class FieldMapping {}

